import type { ContentKind } from '@wix/ai-scheduling-assistant-common-lib/utils';
import type { CalendarPost } from './calendar-item';

export interface ContentMark {
  kind: ContentKind;
  network?: string;
  muted: boolean;
}

export function contentMarkOf(post: Pick<CalendarPost, 'kind' | 'state' | 'preview' | 'idea'> | undefined): ContentMark | undefined {
  if (!post?.state) return undefined;
  const network = post.kind === 'social' ? (post.preview?.network ?? post.idea?.network) : undefined;
  return { kind: post.kind, ...(network ? { network } : {}), muted: post.state === 'idea' };
}
